// extracted by mini-css-extract-plugin
module.exports = {"smallMarginY":"styles-module__smallMarginY___Tu4sm","mediumMarginY":"styles-module__mediumMarginY___25NYx","largeMarginY":"styles-module__largeMarginY___2U3cd"};